import React, { useEffect, useState } from "react";
import { SearchInputWrapper } from "../../../../components/common/datatable/filter/SearchInputWrapper";
import { SearchSelectWithList } from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import {
    createClickableLink,
    SearchSelectWithIndeterminateBoolean
} from "../../../../components/common/datatable/DataTableUtils";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import IconButton from "../../../../components/common/form/IconButton";
import { FaPlus } from "react-icons/fa6";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import {
    useDeleteBulkSubdivisionMutation,
    useLazyExportSubDivisionDataQuery,
    useSearchSubDivisionQuery
} from "../subDivisionApi";
import { useNavigate } from "react-router-dom";
import { useGetAllStatesQuery } from "../../states/statesApi";
import { useLazyGetAllCountyByStateAbbrQuery } from "../../counties/countiesApi";
import { useFindUserSettingsByGroupNameQuery } from "../../../../components/common/userSetting/userSettingsApi";
import { getStateValueFromParam } from "../../../../helpers/utils/Utils";


const Subdivision = () => {

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Subdivisions", url: "" }]
    )

    useEffect(() => {
        document.title = 'Subdivisions';
    }, []);

    const { data: userSetting } = useFindUserSettingsByGroupNameQuery("Subdivision");

    const stateData = useGetAllStatesQuery("");
    const [countyApi, countyData] = useLazyGetAllCountyByStateAbbrQuery();
    const [triggerExportSubDivisionDataQuery] = useLazyExportSubDivisionDataQuery();
    const [deleteBulkSubdivision] = useDeleteBulkSubdivisionMutation();

    const navigate = useNavigate()
  const state = getStateValueFromParam(window);


    useEffect(() => {
        countyApi(state);
    }, [state]);

    const columns: DataTableColumn[] = [
        {
            label: "Name", accessor: "subdivisionKey.name", visibility: { hasShowSetting: false },
            cell: (props: any) => {
                let path = "/subdivisions/" + props.row.original.id;
                return createClickableLink(path, props.value, userSetting, false, "", ["SUBD-R"]);
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Name..."}
                    accessor={"name"} />,
                overrideFilterAccessor: "name"
            }],
        },

        {
            label: "Unit", accessor: "subdivisionKey.unit",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Unit..."}
                    accessor={"unit"} />,
                overrideFilterAccessor: "unit"
            }],
        },

        {
            label: "Phase", accessor: "subdivisionKey.phase",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Phase..."}
                    accessor={"phase"} />,
                overrideFilterAccessor: "phase"
            }],
        },
        {
            label: "Section", accessor: "subdivisionKey.section",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Section..."}
                    accessor={"section"} />,
                overrideFilterAccessor: "section"
            }],
        },
        {
            label: "City", accessor: "city",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter City..."}
                    accessor={"city"} />,
                overrideFilterAccessor: "city"
            }],
        },
        {
            label: "State", accessor: "county.state.stateName", visibility: { hasShowSetting: false },
            filterOptions: [{
                dependentColumns: ["County"],
                filterComponent: SearchSelectWithList(stateData?.data, "stateName", "stateAbbreviation", "Select State...", false, "state"),
                overrideFilterAccessor: "state"
            }],
        },
        {
            label: "County", accessor: "county.countyName", visibility: { hasShowSetting: false },
            filterOptions: [{
                filterComponent: SearchSelectWithList(countyData?.data, "countyName", "id", "Select County...", false, "county"),
                onDependencyUpdated: (value: any) => {
                    countyApi(value)
                },
                overrideFilterAccessor: "county"
            }]
        },

        {
            label: "Code", accessor: "subdivisionCode",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter  Code..."}
                    accessor={"subdivisionCode"} />,
            }],
        },
        {
            label: "Tax Year(s)", accessor: "expectedTaxYear", canSort: false,
            cell: (props: any) => {
                return <>
                    <span>
                        {[props.row.original.expectedTaxYear, props.row.original.expectedTaxYearAlt]
                            .filter(Boolean)
                            .join(" / ")
                        }
                    </span>
                </>
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"number"} placeholder={"Enter  Year..."}
                    accessor={"expectedTaxYear"} />,
            }],
        },

        {
            label: <i className="fa fa-user-check icon_align_center" title={"Has Parent Account?"} />,
            accessor: "hasParentAccount",
            canSort: false,
            cell: (props: { row: { original: { parentAccountList: string | any[]; }; }; }) => <>
                {
                    props.row.original.parentAccountList.length > 0 ? <i title={"Has Parent"} className="fa fa-user-check icon_align_center default-cursor" /> : ''
                }
            </>,
            filterOptions: [{
                filterComponent: SearchSelectWithIndeterminateBoolean("Select Has Parent Account...", "hasParentAccount", "Yes", "No"),
                overrideFilterLabel: "Has Parent Account"
            }]
        },
    ]


    return (
        <div className="user-container px-5 py-5">
            <div className="flex justify-between">
                <Breadcrumb crumbs={crumbs} />
            </div>
            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchSubDivisionQuery,
                    exportAction: triggerExportSubDivisionDataQuery,
                    deleteAction: deleteBulkSubdivision
                }}
                userSettingGroup={"Subdivision"}
                defaultSortOptions={{
                    accessor: "subdivisionKey.name",
                    direction: "asc"
                }}
                defaultFilter={{
                    state:"TX"
                }}
                hasBulkDelete={true}
                rowSelectionOptions={{
                    enableMultiRowSelection: true,
                    onSelectionChange: () => { }

                }}
                buttonOptions={{
                    addButton:
                    {
                        button: <IconButton
                            icon={<FaPlus />}
                            hasBackground={true}
                            onClick={() => {
                                navigate("/subdivisions/create")
                            }}
                            title={"Add Subdivision"}
                        />,
                        permissions: ["SUBD-C"]
                    },
                }}
                basePermission={"SUBD"}
            />
        </div>
    )
};


export default Subdivision;